// extracted by mini-css-extract-plugin
module.exports = {"prevValue":"HistoryTableDataCol_prevValue__3E_RV","dataRow":"HistoryTableDataCol_dataRow__16YU8"};